// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product .right {
  width: 100%;
  /* border: 1px solid pink; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* justify-content: space-between !important; */
  justify-content: flex-start;
  padding: 0px;
  cursor: auto;
  gap: 10px;
}

.product .middle {
  /* border: 1px solid rgb(207, 255, 192) !important; */
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  /* justify-content: space-between !important; */
  padding: 0px !important;
  padding-right: 15px !important;
  gap: 11px;
}

.product .content {
  display: flex;
  /* width: 50%; */
  align-items: flex-start;
  justify-items: center;
  /* height: 40px; */
  /* border: 1px solid yellowgreen; */
}

.product .content-new {
  display: flex;
  /* width: 50%; */
  align-items: center !important;
  justify-content: center !important;
  /* width: 100%; */
  /* height: 100%; */
  /* border: 1px solid red; */
  /* margin: auto; */
}

.product .content-new-0 {
  display: flex;
  /* width: 50%; */
  align-items: flex-start;
  justify-items: center;

  /* height: 40px; */
  /* border: 1px solid yellowgreen; */
}

.product .newIcon {
  display: flex;
  /* width: 50%; */
  align-items: flex-start;
  justify-content: center;
  /* height: 40px; */
  /* border: 1px solid yellowgreen; */
}

.product .content-typo {
  display: flex;
  align-items: center;
  /* height: 40px; */
  font-family: karla !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 14px !important ;
  /* border: 1px solid rgb(0, 255, 115); */
  white-space: nowrap;
}

.product .content-typo-0 {
  display: flex;
  align-items: center;
  /* height: 40px; */
  font-family: karla !important;
  font-size: 18px !important;
  font-weight: 500;
  line-height: 18px !important;
  /* border: 1px solid rgb(38, 0, 255); */
 }

.product .content .btn {
  margin-left: auto;
}

.product .left {
  position: relative;
  /* display: inline-block; */
  width: 100%;
}
.product .left img {
  display: block;
  /* width: 150px;
  height: 153px; */
  width: 100%;
  height: 100%;
  /* border: 1px solid rgb(98, 0, 255); */
}

.product .left .hoverCheck {
  /* position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px; */
  border-radius: 5px;
  display: none; /* Initially hidden */
  /* border: 1px solid red; */
  /* appearance: none; */
}

/* Show the checkbox when hovering over the parent */
.product .left.hover-enabled:hover .hoverCheck {
  display: block;
}

/* Keep the checkbox visible when checked */
.product .left .hoverCheck.Mui-checked {
  display: block;
}

.product .left button {
  position: absolute;
  bottom: 1px;
  left: 50%;

  transform: translateX(-50%);
  background-color: "#FFFFFF";
  color: #50c878;
  font-weight: 500;
  font-size: 18px;
  text-transform: none;
  padding: 2px;
  border-radius: 5px;
  height: 40px;
  width: 110px;
  text-align: center;
}

.product .left .box {
  position: absolute;
  bottom: 1px;
  background-color: "#FFFFFF";
  color: #50c878;
  font-weight: 500;
  font-size: 18px;
  text-transform: none;
  padding: 2px;
  border-radius: 5px;
  height: 40px;
  text-align: center;
  left: 10px;
}

.plus-icon {
  border: 1px solid #50c878;
  width: 41px;
  height: 41px;
  border-radius: 5px;
  background-color: #ffffff;
  color: #50c878;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  font-size: 25px;
  font-weight: 500;
  font-family: poppins;
  cursor: pointer;
}

.quatity-text {
  width: 80px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 41px;
  padding: 8px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 500;
  font-family: poppins;
}
`, "",{"version":3,"sources":["webpack://./src/features/Category/categoryProd/components/product.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,+CAA+C;EAC/C,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,sCAAsC;EACtC,+CAA+C;EAC/C,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;;EAErB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uCAAuC;CACxC;;AAED;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,cAAc;EACd;kBACgB;EAChB,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE;;;;iBAIe;EACf,kBAAkB;EAClB,aAAa,EAAE,qBAAqB;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;;EAET,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".product .right {\n  width: 100%;\n  /* border: 1px solid pink; */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  /* justify-content: space-between !important; */\n  justify-content: flex-start;\n  padding: 0px;\n  cursor: auto;\n  gap: 10px;\n}\n\n.product .middle {\n  /* border: 1px solid rgb(207, 255, 192) !important; */\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  justify-content: flex-start !important;\n  /* justify-content: space-between !important; */\n  padding: 0px !important;\n  padding-right: 15px !important;\n  gap: 11px;\n}\n\n.product .content {\n  display: flex;\n  /* width: 50%; */\n  align-items: flex-start;\n  justify-items: center;\n  /* height: 40px; */\n  /* border: 1px solid yellowgreen; */\n}\n\n.product .content-new {\n  display: flex;\n  /* width: 50%; */\n  align-items: center !important;\n  justify-content: center !important;\n  /* width: 100%; */\n  /* height: 100%; */\n  /* border: 1px solid red; */\n  /* margin: auto; */\n}\n\n.product .content-new-0 {\n  display: flex;\n  /* width: 50%; */\n  align-items: flex-start;\n  justify-items: center;\n\n  /* height: 40px; */\n  /* border: 1px solid yellowgreen; */\n}\n\n.product .newIcon {\n  display: flex;\n  /* width: 50%; */\n  align-items: flex-start;\n  justify-content: center;\n  /* height: 40px; */\n  /* border: 1px solid yellowgreen; */\n}\n\n.product .content-typo {\n  display: flex;\n  align-items: center;\n  /* height: 40px; */\n  font-family: karla !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 14px !important ;\n  /* border: 1px solid rgb(0, 255, 115); */\n  white-space: nowrap;\n}\n\n.product .content-typo-0 {\n  display: flex;\n  align-items: center;\n  /* height: 40px; */\n  font-family: karla !important;\n  font-size: 18px !important;\n  font-weight: 500;\n  line-height: 18px !important;\n  /* border: 1px solid rgb(38, 0, 255); */\n }\n\n.product .content .btn {\n  margin-left: auto;\n}\n\n.product .left {\n  position: relative;\n  /* display: inline-block; */\n  width: 100%;\n}\n.product .left img {\n  display: block;\n  /* width: 150px;\n  height: 153px; */\n  width: 100%;\n  height: 100%;\n  /* border: 1px solid rgb(98, 0, 255); */\n}\n\n.product .left .hoverCheck {\n  /* position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 24px;\n  height: 24px; */\n  border-radius: 5px;\n  display: none; /* Initially hidden */\n  /* border: 1px solid red; */\n  /* appearance: none; */\n}\n\n/* Show the checkbox when hovering over the parent */\n.product .left.hover-enabled:hover .hoverCheck {\n  display: block;\n}\n\n/* Keep the checkbox visible when checked */\n.product .left .hoverCheck.Mui-checked {\n  display: block;\n}\n\n.product .left button {\n  position: absolute;\n  bottom: 1px;\n  left: 50%;\n\n  transform: translateX(-50%);\n  background-color: \"#FFFFFF\";\n  color: #50c878;\n  font-weight: 500;\n  font-size: 18px;\n  text-transform: none;\n  padding: 2px;\n  border-radius: 5px;\n  height: 40px;\n  width: 110px;\n  text-align: center;\n}\n\n.product .left .box {\n  position: absolute;\n  bottom: 1px;\n  background-color: \"#FFFFFF\";\n  color: #50c878;\n  font-weight: 500;\n  font-size: 18px;\n  text-transform: none;\n  padding: 2px;\n  border-radius: 5px;\n  height: 40px;\n  text-align: center;\n  left: 10px;\n}\n\n.plus-icon {\n  border: 1px solid #50c878;\n  width: 41px;\n  height: 41px;\n  border-radius: 5px;\n  background-color: #ffffff;\n  color: #50c878;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  font-size: 25px;\n  font-weight: 500;\n  font-family: poppins;\n  cursor: pointer;\n}\n\n.quatity-text {\n  width: 80px;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 41px;\n  padding: 8px;\n  border-radius: 5px;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: poppins;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
